import React, { useEffect } from "react";
import { CircularProgress } from "@carrier-io/air-react";
import { useNavigate } from "react-router-dom";
import { RoutesPage } from "../../constants/routes";
import {
  deleteLoginCookies,
  getUserLookupData,
  setLoginCookies,
} from "../../utils/cookie";
import Box from "@carrier-io/air-react/Box";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { redirectTo } = getUserLookupData();

  useEffect(() => {
    const isIncludesQueryParams = window.location.search.includes("?");
    const queryParams = isIncludesQueryParams
      ? window.location.search
      : window.location.hash.split("#")[1];

    const params = new URLSearchParams(queryParams);

    const error = params.get("error");
    const accessToken = params.get("access_token");
    const idToken = params.get("id_token");
    const hostname = window.location.hostname;

    if (error) {
      const nextParams = new URLSearchParams();
      nextParams.append("prevError", `Failed to authenticate. ${error}`);
      deleteLoginCookies(hostname);

      navigate({
        pathname: RoutesPage.Login,
        search: nextParams.toString(),
      });
      return;
    }

    if (!accessToken || !idToken) {
      const nextParams = new URLSearchParams();
      nextParams.append(
        "prevError",
        `Failed to authenticate. Unable to retrieve token.`,
      );
      deleteLoginCookies(hostname);
      navigate({
        pathname: RoutesPage.Login,
        search: nextParams.toString(),
      });
      return;
    }

    setLoginCookies({ idToken, accessToken, refreshToken: "" }, hostname);

    if (redirectTo) {
      window.location.href = redirectTo;
    } else {
      navigate({
        pathname: RoutesPage.ConsentModal,
      });
    }
  }, [navigate, redirectTo]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
      }}
    >
      <CircularProgress size="70px" />
    </Box>
  );
};
